import { render, staticRenderFns } from "./HostingKvmIp.vue?vue&type=template&id=386c11d8&scoped=true&"
import script from "./HostingKvmIp.vue?vue&type=script&lang=js&"
export * from "./HostingKvmIp.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmIp.vue?vue&type=style&index=0&id=386c11d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c11d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386c11d8')) {
      api.createRecord('386c11d8', component.options)
    } else {
      api.reload('386c11d8', component.options)
    }
    module.hot.accept("./HostingKvmIp.vue?vue&type=template&id=386c11d8&scoped=true&", function () {
      api.rerender('386c11d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmIp.vue"
export default component.exports